import React, { Component } from 'react';
import '../../css/App.css';
import appStore from '../../store/AppStore'
import { withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import CardPageTitle from '../ShareComponent/CardPageTitle'
import CardResultContent from './CardResultContent'

const styles = {   
 
}

class Result extends Component { 

  render() {
    const { classes } = this.props;

    return (
      <div className="result DonateContent">
        <CardPageTitle pageTitle1="非常感謝您的【贊助本院捐款】" pageTitle2="以下為此次授權結果："/>
        <CardResultContent/>
      </div>
    );
  }
}

export default withStyles(styles)(observer(Result));
